import { Route } from 'react-router-dom';
import { PrivateRoute } from './PrivateRoute';
import { lazy } from 'react';
const Notifications = lazy(() => import('../components/Notifications'));

const Dashboard = lazy(() => import('../components/Dashboard'));
const Prescription = lazy(() => import('../components/Prescription'));
const SubmittedPrescription = lazy(() =>
  import('../components/Prescription/SubmittedPrescription'),
);
const NewPrescription = lazy(() => import('../components/Prescription/NewPrescription'));
const PreAuths = lazy(() => import('../components/PreAuths'));
const SubmittedPreAuth = lazy(() => import('../components/PreAuths/SubmittedPreAuth'));
const ClaimAppeal = lazy(() => import('../components/Claims/ClaimAppeal'));
const PreAuthDetails = lazy(() => import('../components/PreAuths/PreAuthDetails'));
const CreatePreAuth = lazy(() => import('../components/PreAuths/CreatePreAuth'));

const Claims = lazy(() => import('../components/Claims'));
const SubmittedClaim = lazy(() => import('../components/Claims/SubmittedClaim'));
const ClaimDetail = lazy(() => import('../components/Claims/ClaimDetail'));
const CreateNewClaim = lazy(() => import('../components/Claims/CreateClaim'));
const Reports = lazy(() => import('../components/Reports'));

const Payments = lazy(() => import('../components/Payments'));
const PaymentDetails = lazy(() => import('../components/PaymentDetails'));

const PrescriptionDetail = lazy(() => import('../components/Prescription/PrescriptionDetail'));

const Visits = lazy(() => import('../components/Visits'));
const CreateVisit = lazy(() => import('../components/Visits/CreateVisit'));
const VisitDetails = lazy(() => import('../components/Visits/VisitDetails'));

const Profile = lazy(() => import('../components/Profile'));
const Support = lazy(() => import('../components/Support'));

const ScreeningDashboard = lazy(() => import('../components/Screening/Dashboard'));
const NewScreening = lazy(() =>
  import('../components/Screening/Screenings/NewScreening/NewScreening'),
);
const AddData = lazy(() => import('../components/Screening/Screenings/NewScreening/AddData'));

const WellnessDashboard = lazy(() => import('../components/Wellness/Dashboard'));
const WellnessClaims = lazy(() => import('../components/Wellness/Claims'));
const WellnessClaimDetails = lazy(() => import('../components/Wellness/Claims/Details'));
const WellnessAppointments = lazy(() => import('../components/Wellness/Appointments/Index'));
const Drugs = lazy(() => import('../components/Drugs'));
const MonthlyReports = lazy(() => import('../components/Reports/Monthly_Reports'));

const CreateExtension = lazy(() => import('../components/Extensions/CreateExtension'));
const ExtensionList = lazy(() => import('../components/Extensions/ExtensionList'));
const ExtensionDetail = lazy(() => import('../components/Extensions/ExtensionDetail'));

export const hospitalsWithScreening = (
  <>
    <Route
      path="/"
      element={
        <PrivateRoute>
          <Dashboard />
        </PrivateRoute>
      }
    />
    <Route
      path="/prescription"
      element={
        <PrivateRoute>
          <Prescription />
        </PrivateRoute>
      }
    />
    <Route
      path="/prescriptions/submitted"
      element={
        <PrivateRoute>
          <SubmittedPrescription />
        </PrivateRoute>
      }
    />
    <Route
      path="/prescription/:prescriptionNumber"
      element={
        <PrivateRoute>
          <PrescriptionDetail />
        </PrivateRoute>
      }
    />
    <Route
      path="/prescriptions/add"
      element={
        <PrivateRoute>
          <NewPrescription />
        </PrivateRoute>
      }
    />
    <Route
      path="/pre-auths"
      element={
        <PrivateRoute>
          <PreAuths />
        </PrivateRoute>
      }
    />
    <Route
      path="/pre-auths/submitted"
      element={
        <PrivateRoute>
          <SubmittedPreAuth />
        </PrivateRoute>
      }
    />
    <Route
      path="/pre-auths/:preauth_id/extension"
      element={
        <PrivateRoute>
          <CreateExtension />
        </PrivateRoute>
      }
    />
    <Route
      path="/pre-auths/:preauth_id"
      element={
        <PrivateRoute>
          <PreAuthDetails />
        </PrivateRoute>
      }
    />
    <Route
      path="/pre-auths/request"
      element={
        <PrivateRoute>
          <CreatePreAuth />
        </PrivateRoute>
      }
    />
    <Route
      path="/extensions"
      element={
        <PrivateRoute>
          <ExtensionList />
        </PrivateRoute>
      }
    />
    <Route
      path="/extensions/:extension_id"
      element={
        <PrivateRoute>
          <ExtensionDetail />
        </PrivateRoute>
      }
    />
    <Route
      path="/claims"
      element={
        <PrivateRoute>
          <Claims />
        </PrivateRoute>
      }
    />
        <Route
      path="/claims/:claim_id/appeal"
      element={
        <PrivateRoute>
          <ClaimAppeal />
        </PrivateRoute>
      }
    />
    <Route
      path="/claims/submitted"
      element={
        <PrivateRoute>
          <SubmittedClaim />
        </PrivateRoute>
      }
    />
    <Route
      path="/claims/request"
      element={
        <PrivateRoute>
          <CreateNewClaim />
        </PrivateRoute>
      }
    />
    <Route
      path="/claims/:claim_id"
      element={
        <PrivateRoute>
          <ClaimDetail />
        </PrivateRoute>
      }
    />
    <Route
      path="/reports"
      element={
        <PrivateRoute>
          <Reports />
        </PrivateRoute>
      }
    />
    <Route
      path="/payments"
      element={
        <PrivateRoute>
          <Payments />
        </PrivateRoute>
      }
    />
    <Route
      path="/payments/:batchId"
      element={
        <PrivateRoute>
          <PaymentDetails />
        </PrivateRoute>
      }
    />
    <Route
      path="/visits/"
      element={
        <PrivateRoute>
          <Visits />
        </PrivateRoute>
      }
    />
    <Route
      path="/visits/:visitID"
      element={
        <PrivateRoute>
          <VisitDetails />
        </PrivateRoute>
      }
    />
    <Route
      path="/visits/request/:memberNo"
      element={
        <PrivateRoute>
          <CreateVisit />
        </PrivateRoute>
      }
    />
    <Route
      path="/support"
      element={
        <PrivateRoute>
          <Support />
        </PrivateRoute>
      }
    />
    <Route path="/profile" element={<Profile />} />
    <Route
      path="/notifications"
      element={
        <PrivateRoute>
          <Notifications />{' '}
        </PrivateRoute>
      }
    />
    <Route
      path="/drugs"
      element={
        <PrivateRoute>
          <Drugs />
        </PrivateRoute>
      }
    />

    <Route
      path="/screening"
      element={
        <PrivateRoute>
          <ScreeningDashboard />
        </PrivateRoute>
      }
    />
    <Route
      path="/screening/new-screening"
      element={
        <PrivateRoute>
          <NewScreening />
        </PrivateRoute>
      }
    />
    <Route
      path="/screening/new-screening/add-data"
      element={
        <PrivateRoute>
          <AddData />
        </PrivateRoute>
      }
    />
    <Route
      path="/reports/monthly"
      element={
        <PrivateRoute>
          <MonthlyReports />
        </PrivateRoute>
      }
    />
  </>
);
